import _defineProperty from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import useStyles from './styles';
import clsx from 'clsx';

var Overlay = function Overlay(_ref) {
  var _clsx;

  var children = _ref.children,
      _ref$customClassName = _ref.customClassName,
      customClassName = _ref$customClassName === void 0 ? '' : _ref$customClassName,
      _ref$inlineStyles = _ref.inlineStyles,
      inlineStyles = _ref$inlineStyles === void 0 ? {} : _ref$inlineStyles,
      _ref$onClickOverlay = _ref.onClickOverlay,
      onClickOverlay = _ref$onClickOverlay === void 0 ? function () {} : _ref$onClickOverlay;
  var classes = useStyles();
  var containerStyle = clsx((_clsx = {}, _defineProperty(_clsx, classes.container, true), _defineProperty(_clsx, customClassName, Boolean(customClassName)), _clsx));
  var jsx = React.createElement(React.Fragment, null, React.createElement("div", {
    className: containerStyle,
    style: inlineStyles,
    onClick: onClickOverlay
  }), children);
  return jsx;
};

Overlay.propTypes = {
  children: PropTypes.node,
  onClickOverlay: PropTypes.func,
  open: PropTypes.bool,
  animationConfig: PropTypes.shape({
    to: PropTypes.object.isRequired,
    config: PropTypes.object
  }),
  node: PropTypes.string,
  customClassName: PropTypes.string,
  inlineStyles: PropTypes.object
};
export { Overlay };